<template>
  <div class="wrap">
    <NavBar
      :title="$t('pages.editPhone')"
      left-arrow
      @click-left="$router.go(-1)"
    ></NavBar>
    <Form @submit="onSubmit">
      <Field
        v-model="phoneValue"
        name="phone"
        :label="$t('editPhone.label')"
        :placeholder="$t('editPhone.placeholder')"
        :rules="[{ required: true, message: $t('editPhone.hint') }]"
      />
      <div style="margin: 16px">
        <Button round block type="info" native-type="submit" class="submit">{{
          $t("Button.submit")
        }}</Button>
      </div>
    </Form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { NavBar, Field, Form, Button } from "vant";
import { $post } from "@/utils";
export default {
  components: {
    NavBar,
    Field,
    Form,
    Button,
  },
  data() {
    return {
      phone: "",
    };
  },
  methods: {
    async onSubmit(values) {
      console.log(values);
      try {
        const res = await $post("/users/edit/userphone", {
          newuserphone: values.phone,
        });
        this.$store.dispatch("getUserInfo");
        this.$router.go(-1);
      } catch (error) {}
    },
  },
  computed: {
    ...mapGetters(["userInfo"]),
    phoneValue: {
      get() {
        return this.phone || this.userInfo.userphone;
      },
      set(val) {
        this.phone = val;
        return val;
      },
    },
  },
};
</script>

<style lang="less" scoped>
.submit {
  background: var(--nav-background);
  border: none;
}
</style>